import { render, staticRenderFns } from "./DetailsRow.vue?vue&type=template&id=bf34e5bc&scoped=true"
import script from "./DetailsRow.vue?vue&type=script&lang=js"
export * from "./DetailsRow.vue?vue&type=script&lang=js"
import style0 from "./DetailsRow.vue?vue&type=style&index=0&id=bf34e5bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf34e5bc",
  null
  
)

export default component.exports